export class UIConfigClass {

  constructor(){
    if (UIConfigClass.instance) {
      return UIConfigClass.instance
    }
    UIConfigClass.instance = this

    this.parametrs = {
      isLocal: true,
      locale: 'en',

      totalWidth: 2778,
      totalHeight: 2778,
      landscapePaytable: true,
      desktopMenuPosition: [550, 1700],

      assetsPath: "../pixiUISimpleLibrary/assets/final/json/uiAssetsConfig.json",
      fontsPath: "../pixiUISimpleLibrary/assets/final/font/fonts.css",



      autoSingleWinValues: ['-', 'x3', 'x5', 'x10', 'x20', 'x50', 'x100'],

      autoStopBalanceLowerValues: [0,0.5,0.75],
      autoStopBalanceHigherValues: [1.5,2,5],
      autoStopMoneyExceedValues: ['5','10','50', '100', '1000'],

      fonts: ['Roboto, Noto Serif'],
      pattern: null,
      app: null,
      changeUIConfig: this.changeUIConfig.bind(this)

    }
  }

  get UIConfig(){
    return this.parametrs
  }

  changeUIConfig(key, value){
    this.parametrs[key] = value
  }
}

export default new UIConfigClass().UIConfig
